import React from "react";
import { Link, useNavigate } from "react-router-dom";
import moulogo from "../../assets/mouLogo.png";
import Button from "../Button";

const NavbarPersonas = () => {
  const navigate = useNavigate();

  return (
    <nav className="fixed top-12 left-0 w-full bg-[#e8f2f4] p-4 hidden lg:flex items-center justify-between shadow-md px-5 z-50">
      <div className="flex items-center">
        <Link to="/personas">
          <img src={moulogo} alt="MEU Aliado" className="h-12" />
        </Link>
      </div>
      <div className="flex items-center space-x-6">
        <ul className="flex space-x-10 text-blue-700 font-bold">
          <li><Link to="/personas/misFICs" className="hover:underline">MisFICs</Link></li>
          <li><Link to="/personas/simula-tu-cdt" className="hover:underline">MisCDTs</Link></li>
          <li><Link to="/personas/miPension" className="hover:underline">MiPensión</Link></li>
          <li>
            <button
              type="button"
              onClick={() => navigate("/personas")}
              className="hover:underline focus:outline-none"
            >
              Trámites digitales
            </button>
          </li>
          <li>
            <Link to="/blog/educacion-financiera" className="hover:underline">
              Educación Financiera
            </Link>
          </li>
          <li><Link to="/personas/dashboard" className="hover:underline">Dashboard</Link></li>
        </ul>
        <Button
          text="Iniciar sesión"
          color="bg-blue-600"
          textColor="text-white"
          paddingX="px-4"
          paddingY="py-2"
          border="border-transparent"
          onClick={() => navigate("/personas/iniciar-sesion")}
        />
      </div>
    </nav>
  );
};

export default NavbarPersonas;
